export default __webpack_public_path__ + "src/components/pages/placement/shared/images/1c6009a29edd9b3a8690af70a4b9b3bd.png";